import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index';
import { Spinner } from '../../../../../common/index';
import ErasmusSubjectsEditForm from './ErasmusSubjectsForm/ErasmusSubjectsEditForm.jsx';
import {
  useGetErasmusSubjectsQuery,
  useGetErasmusSubjectQuery,
  useSaveErasmusSubjectMutation,
} from '../../../../../../redux/services/erasmusSubjects';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import { useGetErasmusUniversitiesQuery } from '../../../../../../redux/services/erasmusUniversities';
import { useGetStudySubjectsQuery } from '../../../../../../redux/services/study_subjects';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const ErasmusSubjectsEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isPreview = mode === 'preview';

  const { data: subjectDetail, isLoading } = useGetErasmusSubjectQuery(id, {
    skip: !isEdit && !isPreview,
  });
  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const [saveErasmusSubject, { isSuccess: isSaveSuccess }] =
    useSaveErasmusSubjectMutation();

  const { refetch } = useGetErasmusSubjectsQuery();
  const { data: universities } = useGetErasmusUniversitiesQuery();
  const { data: localSubjects } = useGetStudySubjectsQuery();
  const [filteredSubjects, setFilteredSubjects] = useState();

  useEffect(() => {
    if (subjectDetail) {
      setFilteredSubjects(subjectDetail?.subject.local_subjects || []);
    }
  }, [subjectDetail]);

  const handleLocalSubjectsDelete = (deletedUniversity) => {
    const deletedId =
      deletedUniversity?.id ?? deletedUniversity?.study_subject_id;

    const data = filteredSubjects.filter(
      (subject) => (subject?.id ?? subject?.study_subject_id) !== deletedId,
    );
    setFilteredSubjects(data);
  };

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsErasmusSubjects);
      refetch();
    }
  }, [isSaveSuccess]);

  const title = (isCreate && t('Pridanie predmetu')) || t('Úprava predmetu');

  if (
    isLoading ||
    (isEdit && !subjectDetail) ||
    !universities ||
    !localSubjects
  ) {
    return <Spinner />;
  }
  const initials =
    isEdit || isPreview
      ? {
          ...subjectDetail.subject,
        }
      : {
          name: undefined,
        };

  if (!initials) {
    return <Spinner />;
  }
  return (
    <>
      {isPreview ? null : (
        <AppBarCMS
          title={title}
          backUrl={routes.cmsErasmusSubjects}
          backUrlTooltip={t('Konzorciá')}
          permissionsBasic={'erasmus-applications'}
        />
      )}
      <div style={{ margin: '10px' }}>
        <ErasmusSubjectsEditForm
          initials={initials}
          isEdit={isEdit}
          isPreview={isPreview}
          isCreate={isCreate}
          universities={universities}
          localSubjects={localSubjects}
          filteredSubjects={filteredSubjects}
          onLocalSubjectDelete={(row) => {
            handleLocalSubjectsDelete(row);
            //deleteConsortiumUniversity(row.pivot)
          }}
          onSubmit={(values) => {
            const existingIds = filteredSubjects
              ? filteredSubjects
                  .map((item) => item?.id ?? item?.study_subject_id)
                  .filter(
                    (id) =>
                      id !== null &&
                      id !== undefined &&
                      String(id).trim() !== '',
                  )
              : [];
            const selectedIds = Array.isArray(values.choosedLocalSubjectsId)
              ? values.choosedLocalSubjectsId
              : [];
            const subjectsToSend = Array.from(
              new Set(
                [...existingIds, ...selectedIds]
                  .map((id) => Number(id))
                  .filter((id) => Number.isInteger(id) && id > 0),
              ),
            );
            const body = { ...values, choosedLocalSubjectsId: subjectsToSend };
            // if (id && choosedSubjectsIds.length != 0) {
            //   saveSubjectsPivot({ body: choosedSubjectsIds, id: id });
            // }
            saveErasmusSubject({ body: body, id: id });
          }}
        />
      </div>
    </>
  );
};

export default ErasmusSubjectsEdit;
